<template>
    <VJoyDialog
        ref="securityCheckDialogRef"
        pattern-confirm
        :confirm-text="$t('account.security.check.cancel.dialog.confirm.btn')"
        :cancel-text="$t('account.security.check.cancel.dialog.cancel.btn')"
        data-testid="security-check-cancel-dialog"
        @dialog:confirm="onLeave"
        @dialog:hide="emit('cancel')"
    >
        <template #dialog-header>
            {{ $t('account.security.check.cancel.dialog.header') }}
        </template>

        <template #dialog-body>
            {{ $t('account.security.check.cancel.dialog.body') }}
        </template>
    </VJoyDialog>
</template>

<script setup lang="ts">
    import {useTemplateRef} from 'vue';
    import {storeToRefs} from 'pinia';
    import {watch} from '#imports';
    import {safelyNavigateTo} from '@malt/utils';
    import {VJoyDialog} from '@maltjoy/core-vue';
    import {useRedirectParamsStore} from '~/store/redirect-params.store';

    const props = defineProps<{open: boolean}>();

    const emit = defineEmits<{cancel: []}>();

    const redirectParamsStore = useRedirectParamsStore();
    const {isInAccountSettings, dropRedirect} = storeToRefs(redirectParamsStore);

    const securityCheckDialogRef = useTemplateRef('securityCheckDialogRef');

    watch(
        () => props.open,
        () => {
            if (props.open) {
                securityCheckDialogRef.value?.show();
            }
        },
    );

    function onLeave() {
        if (isInAccountSettings.value) {
            safelyNavigateTo('/phone?phone=not-verified');
            return;
        }

        safelyNavigateTo(dropRedirect.value, {externalToThisApp: true});
    }
</script>
